var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesIndentFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48931_2010)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#3A3A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2H12.1667L16.3333 6.16667V9.67784V12.1667C16.3333 15.4804 13.647 18.1667 10.3333 18.1667H9H4.66667C4.22464 18.1667 3.80072 17.9911 3.48816 17.6785C3.17559 17.3659 3 16.942 3 16.5V3.66667C3 3.22464 3.17559 2.80072 3.48816 2.48816C3.80072 2.17559 4.22464 2 4.66667 2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.332 1.5V5.33319C11.332 5.77521 11.5076 6.19914 11.8202 6.5117C12.1327 6.82426 12.5567 6.99985 12.9987 6.99985L16.9988 7",
    stroke: "#3A3A40",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81357 11.3466C9.78192 11.272 9.77326 11.1897 9.78872 11.1102C9.80417 11.0307 9.84303 10.9576 9.90031 10.9003C9.95759 10.843 10.0307 10.8042 10.1102 10.7887C10.1897 10.7733 10.272 10.7819 10.3466 10.8136L19.1484 13.9911C19.2283 14.0238 19.2958 14.0811 19.341 14.1547C19.3863 14.2283 19.3899 14.4661 19.4004 14.4004C19.4109 14.3347 19.3598 14.5683 19.3037 14.6339C19.2475 14.6996 19.172 14.7457 19.088 14.7657L15.5359 15.9313C15.3893 15.9663 15.2553 16.0412 15.1487 16.1477C15.0421 16.2542 14.967 16.3881 14.9318 16.5346L13.9002 20.4002C13.8805 20.4845 13.8344 20.5604 13.7686 20.6168C13.7029 20.6732 13.6209 20.7072 13.5346 20.7139C13.4482 20.7206 13.362 20.6997 13.2883 20.6542C13.2147 20.6087 13.1574 20.5409 13.1248 20.4606L9.81357 11.3466Z",
    fill: "white",
    stroke: "#3A3A40",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4241 11.8159C10.4009 11.7611 10.3945 11.7006 10.4059 11.6422C10.4172 11.5837 10.4458 11.53 10.4879 11.4879C10.53 11.4458 10.5837 11.4172 10.6422 11.4059C10.7006 11.3945 10.7611 11.4009 10.8159 11.4241L17.4159 14.1241C17.4747 14.1482 17.5243 14.1904 17.5576 14.2444C17.5908 14.2985 17.6061 14.3617 17.6012 14.425C17.5962 14.4883 17.5713 14.5484 17.5301 14.5967C17.4888 14.6449 17.4333 14.6788 17.3715 14.6935L14.7621 15.3181C14.6544 15.3439 14.5559 15.3989 14.4776 15.4772C14.3992 15.5554 14.344 15.6539 14.3181 15.7615L13.6941 18.3715C13.6796 18.4335 13.6457 18.4893 13.5974 18.5307C13.5491 18.5722 13.4888 18.5972 13.4254 18.6021C13.3619 18.6071 13.2985 18.5917 13.2444 18.5582C13.1902 18.5247 13.1481 18.4749 13.1241 18.4159L10.4241 11.8159Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48931_2010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIndentFilledV2);
export default __webpack_public_path__ + "static/media/salesIndentFilledV2.9b8a6444d8705315af2a05ca4f33a166.svg";
export { ForwardRef as ReactComponent };